var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 140,
    viewBox: "0 0 537 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8970_72)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8970_72)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 497,
    height: 100,
    rx: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 271.629,
    height: 358.967,
    transform: "translate(138.866 -189.246) rotate(30.8804)",
    fill: "#E42125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.676 80H112.648C110.708 80 108.944 79.6354 107.355 78.9062C105.767 78.1771 104.406 77.181 103.273 75.918C102.154 74.6549 101.288 73.1706 100.676 71.4648C100.064 69.7591 99.7578 67.9362 99.7578 65.9961C99.7578 64.069 100.064 62.2591 100.676 60.5664C101.288 58.8607 102.154 57.3763 103.273 56.1133C104.406 54.8372 105.767 53.8346 107.355 53.1055C108.944 52.3633 110.708 51.9922 112.648 51.9922H130.676V55.9961H112.648C111.268 55.9961 110.025 56.263 108.918 56.7969C107.824 57.3177 106.893 58.0339 106.125 58.9453C105.37 59.8438 104.784 60.8984 104.367 62.1094C103.964 63.3203 103.762 64.6159 103.762 65.9961C103.762 67.3763 103.964 68.6784 104.367 69.9023C104.784 71.1133 105.37 72.1745 106.125 73.0859C106.893 73.9844 107.824 74.694 108.918 75.2148C110.025 75.7357 111.268 75.9961 112.648 75.9961H130.676V80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.93 80H201.926V68.0078H182.355V64.0039H201.926V51.9922H205.93V80ZM180.363 80H176.359V51.9922H180.363V80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.195 80H281.191V71.9922H258.848V68.0078H281.191V55.9961H266.836C265.469 55.9961 264.18 56.263 262.969 56.7969C261.758 57.3177 260.703 58.0339 259.805 58.9453C258.906 59.8438 258.19 60.8984 257.656 62.1094C257.135 63.3203 256.875 64.6159 256.875 65.9961V80H252.871V65.9961C252.871 64.707 253.034 63.4701 253.359 62.2852C253.698 61.0872 254.167 59.974 254.766 58.9453C255.378 57.9036 256.107 56.9596 256.953 56.1133C257.812 55.2539 258.756 54.5182 259.785 53.9062C260.827 53.2943 261.94 52.8255 263.125 52.5C264.31 52.1615 265.547 51.9922 266.836 51.9922H285.195V80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.277 71.9922C363.277 73.112 363.069 74.1602 362.652 75.1367C362.236 76.1003 361.663 76.9466 360.934 77.6758C360.217 78.3919 359.371 78.9583 358.395 79.375C357.431 79.7917 356.396 80 355.289 80H330.953V75.9961H355.289C355.849 75.9961 356.37 75.8919 356.852 75.6836C357.333 75.4753 357.75 75.1888 358.102 74.8242C358.466 74.4596 358.753 74.0365 358.961 73.5547C359.169 73.0599 359.273 72.5391 359.273 71.9922C359.273 71.4453 359.169 70.931 358.961 70.4492C358.753 69.9674 358.466 69.5443 358.102 69.1797C357.75 68.8151 357.333 68.5286 356.852 68.3203C356.37 68.112 355.849 68.0078 355.289 68.0078H338.961C337.867 68.0078 336.832 67.7995 335.855 67.3828C334.879 66.9661 334.026 66.3997 333.297 65.6836C332.581 64.9544 332.008 64.1016 331.578 63.125C331.161 62.1484 330.953 61.1068 330.953 60C330.953 58.9062 331.161 57.8711 331.578 56.8945C332.008 55.918 332.581 55.0716 333.297 54.3555C334.026 53.6263 334.879 53.0534 335.855 52.6367C336.832 52.207 337.867 51.9922 338.961 51.9922H361.285V55.9961H338.961C338.414 55.9961 337.893 56.1003 337.398 56.3086C336.917 56.5169 336.493 56.8034 336.129 57.168C335.764 57.5326 335.478 57.9622 335.27 58.457C335.061 58.9388 334.957 59.4531 334.957 60C334.957 60.5469 335.061 61.0677 335.27 61.5625C335.478 62.0443 335.764 62.4674 336.129 62.832C336.493 63.1966 336.917 63.4831 337.398 63.6914C337.893 63.8997 338.414 64.0039 338.961 64.0039H355.289C356.396 64.0039 357.431 64.2188 358.395 64.6484C359.371 65.0651 360.217 65.638 360.934 66.3672C361.663 67.0833 362.236 67.9297 362.652 68.9062C363.069 69.8698 363.277 70.8984 363.277 71.9922Z",
    fill: "#E42125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.324 79H408.359V50.9922H437.324V54.9961H412.363V74.9961H437.324V79ZM433.926 67.0078H414.355V63.0039H433.926V67.0078Z",
    fill: "#E42125"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8970_72",
    x: 0,
    y: 0,
    width: 537,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8970_72"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8970_72",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8970_72"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 497,
    height: 100,
    rx: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaseLogo);
export default __webpack_public_path__ + "static/media/CHASE_LOGO.8118ce1b1d4662684f7c81b31619bc21.svg";
export { ForwardRef as ReactComponent };